module.exports = __webpack_public_path__ + "media/images/icons/icn_048-82e6117a5ce155eb969b676e16268095.svg";